import { AxiosResponse } from 'axios'
import axios from 'axios'
import { AppConfigItem, AppInstall, Config, IConsentsData, RawConsentsData, PrivacyAndTerms, ProfileConfig, RawConfig } from './models'

export const getWorkspaceConfig = async (
  endpoint: string,
  slug: string
): Promise<Config> => {
  const url = `${endpoint}/${slug}/.config/workspace/`
  const response: AxiosResponse<RawConfig> = await axios.get(url)
  return <Config>{
    id: response.data.id,
    slug: response.data.slug,
    name: response.data.name,
    description: response.data.description,
    color: response.data.color,
    image: response.data.image,
    apps: response.data.apps.map(
      (item1) =>
        <AppInstall>{
          id: item1.id,
          appId: item1.app_id,
          name: item1.name,
          slug: item1.slug,
          description: item1.description,
          type: item1.type,
          version: item1.version,
          config: item1.config.map(
            (item2) =>
              <AppConfigItem>{
                id: item2.id,
                key: item2.key,
                value: item2.value,
              }
          ),
        }
    ),
    display_point: response.data.display_point,
    method_calculate_member_level: response.data.method_calculate_member_level,
    maintaining_period: response.data.maintaining_period,
    point_unit: response.data.point_unit,
    profileConfig: <ProfileConfig>{
      firstName: response.data.profile_config.first_name,
      lastName: response.data.profile_config.last_name,
      gender: response.data.profile_config.gender,
      email: response.data.profile_config.email,
      birthdate: response.data.profile_config.birthdate,
      address: response.data.profile_config.address,
      branch: response.data.profile_config.branch,
    },
    privacyAndTerms:
      <PrivacyAndTerms>{
        term: {
          id: response.data.privacy_and_terms.term.id,
          content: response.data.privacy_and_terms.term.content,
          status: response.data.privacy_and_terms.term.status,
          publishedDate: response.data.privacy_and_terms.term.published_date,
          order: response.data.privacy_and_terms.term.order,
        },
        privacy: {
          id: response.data.privacy_and_terms.privacy.id,
          content: response.data.privacy_and_terms.privacy.content,
          status: response.data.privacy_and_terms.privacy.status,
          publishedDate: response.data.privacy_and_terms.privacy.published_date,
          order: response.data.privacy_and_terms.privacy.order,
        }
      },
    consentData: response.data.consents.map(
      (item: RawConsentsData) =>
        <IConsentsData>{
          id: item.id,
          consentId: item.consent_id,
          labelEn: item.label_en,
          labelTh: item.label_th
        }
    ),
  }
}
